import { useEffect, useMemo, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { isBidExpired } from '../utils/orderExpiry';

// Sanntidslytting på åpne oppdrag (onSnapshot), filtrert til samme Stripe-modus
// (test/live) som den innloggede sjåføren — se firestore.rules for håndhevingen
// ved selve matchingen; dette er kun et UX-filter.
// Anbudsoppdrag med utløpt anbudsfrist skjules fra markedsplassen (dataene endres ikke;
// bestiller får varsel og kan endre/publisere på nytt). Fastpris utløper aldri.
export function useOpenOrders(isTestAccount = false) {
  const [rawOrders, setRawOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);
  const [now, setNow]         = useState(() => new Date());

  useEffect(() => {
    setLoading(true);

    const q = query(
      collection(db, 'orders'),
      where('status', '==', 'open'),
      where('isTestAccount', '==', isTestAccount)
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        setRawOrders(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        setLoading(false);
      },
      (err) => {
        console.error('useOpenOrders:', err);
        setError(err);
        setLoading(false);
      }
    );

    return unsubscribe;
  }, [isTestAccount]);

  // Fristen kan passere mens siden er åpen.
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60 * 1000);
    return () => clearInterval(id);
  }, []);

  const orders = useMemo(() => rawOrders.filter(o => !isBidExpired(o, now)), [rawOrders, now]);

  return { orders, loading, error };
}
